import React, { useEffect, useState } from "react";
import Categorie from "../home/CoursesSection/Categorie";
import auth from "../../services/authServices";
import http from "../../services/httpServices";
import LoadingIcon from "../../components/ui/LoadingIcon";
import Button from "../../components/ui/Button";
import CenterIcon from "../../components/ui/CenterIcon";

import cloudDecore from "../../assets/sahaba-assets/cloudDecore.png";

import Heading from "../../components/NewUi/heading/Heading";
const useFetchedCourses = () => {
    const [courses, setCourses] = useState(false);
    const [isCoursesFetchingLoading, setIsCoursesFetchingLoading] = useState(true);
    const [isCoursesFetchingError, setIsCoursesFetchingError] = useState(false);

    const getCourses = async () => {
        setIsCoursesFetchingLoading(true);
        try {
            const token = auth.getToken();
            const config = auth.getAuthConfig(token);
            const { data: response } = await http.get(`/api/courses/featured_courses`, config);
            setCourses(response);
            setIsCoursesFetchingLoading(false);
        } catch (error) {
            setIsCoursesFetchingError(true);
            setIsCoursesFetchingLoading(false);
        }
    };
    const handleFetchedCourses = () => {
        getCourses();
    };

    return {
        courses,
        isCoursesFetchingLoading,
        isCoursesFetchingError,
        getCourses,
        handleFetchedCourses,
    };
};
const FeaturedCoursesSection = () => {
    const {
        courses,
        isCoursesFetchingLoading,
        isCoursesFetchingError,
        getCourses,
        handleFetchedCourses,
    } = useFetchedCourses();

    useEffect(() => {
        if (!courses) {
            getCourses();
        }
    }, [courses]);

    return (
        <section className="min-h-screen my-20 flex justify-center flex-col w-full">
            <div className=" relative flex-center-both flex-col space-y-8 pb-8">
                <div className="mx-auto">
                    <Heading title="إقتراحنا لــــــيك !" />
                </div>
                <div className=" absolute z-10 flex justify-between left-20 right-20 opacity-40">
                    <img src={cloudDecore} alt="cloudDecore" className="w-20  animate-pulse" />
                    <img src={cloudDecore} alt="cloudDecore" className="w-20  animate-pulse" />
                </div>
                <p className=" w-full md:w-1/4 text-lg  text-gray-500 dark:text-gray-200 smooth text-center">
                    أنت حيث تضع نفسك! 💡دي رحلات هتخليك تروح في حتة تانية اختار اللي يناسبك , ويلا
                    نطير مع بعض
                </p>
            </div>
            <div>
                {isCoursesFetchingError ? (
                    <div className="font-w-bold rounded-md bg-third-container clr-text-primary border border-secondary-container smooth p-5 flex-center-both space-x-3 space-x-reverse">
                        <CenterIcon icon="bxs:error" className="font-h1 text-rose-500" />
                        <span>حدث خطأ اثناء تحميل الكورسات</span>
                    </div>
                ) : isCoursesFetchingLoading ? (
                    <div className="font-w-bold rounded-md bg-third-container clr-text-primary border border-secondary-container smooth p-5 flex-center-both space-x-3 space-x-reverse">
                        <span className="font-h1">
                            <LoadingIcon />
                        </span>
                        <span>يتم الآن تحميل الكورسات</span>
                    </div>
                ) : courses.length > 0 ? (
                    <div className="max-w-7xl pb-7 mx-auto">
                        <Categorie
                            layout="carousel"
                            coursesList={courses?.slice(0, 10)}
                            noCoursesPlaceholder="لا يوجد كورسات متاحة"
                        />
                    </div>
                ) : (
                    <div className="flex-center-both">
                        <div className="border-2 rounded-md border-orange-300 dark:border-orange-500 p-10 bg-orange-100 dark:bg-opacity-5 smooth clr-text-primary">
                            سيتم اضافة الكورسات قريبًا
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default FeaturedCoursesSection;
